import { call, put, select } from 'redux-saga/effects';

import api from '../../../../services/api';
import * as Actions from './actions';

export function* search() {
  try {
    const client = yield call(api, 'protocolo');

    const { filtros, name } = yield select((state) => state.protocoloBusca);

    const response = yield call(client.post, `consultasql/exec/${name}`, {
      filter: filtros,
    });
    yield put(Actions.searchSuccess(response.data));
  } catch (error) {
    yield put(Actions.searchFailure());
  }
}

export function* searchTotais() {
  try {
    const client = yield call(api, 'protocolo');

    const response = yield call(client.get, 'buscaTotais');
    yield put(Actions.searchTotaisSuccess(response.data));
  } catch (error) {
    yield put(Actions.searchFailure());
  }
}

export function* searchFilters() {
  try {
    const { name } = yield select((state) => state.protocoloBusca);
    const client = yield call(api, 'protocolo');
    const response = yield call(
      client.post,
      `consulta/exec/dinamico-${name}`,
    );
    yield put(Actions.searchDinamicFiltersSuccess(response.data));
  } catch (error) {
    yield put(Actions.searchFailure());
  }
}
